import { useEffect, useRef } from 'react'

export function useTransitionEndEffect(callback: (e: TransitionEvent) => void) {
  const elementRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = elementRef.current

    element?.addEventListener('transitionend', callback)

    return () => {
      element?.removeEventListener('transitionend', callback)
    }
  }, [callback])

  return elementRef
}
